import '@fortawesome/fontawesome-free/css/all.min.css'
import "react-datetime/css/react-datetime.css";
import './styles/main.css'

import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { QueryClient, QueryClientProvider } from 'react-query';
import { App } from './App';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Theme } from 'react-daisyui'
import TagManager from 'react-gtm-module'
import { GoogleOAuthProvider } from '@react-oauth/google'

library.add(fas)

TagManager.initialize({ gtmId: 'GTM-PRSBPGWD' })

const container = document.getElementById('root')
const root = createRoot(container!)

const queryClient = new QueryClient({
    defaultOptions: {
    },
})

// You should replace this with your actual Google Client ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id';

root.render(
    <QueryClientProvider client={queryClient}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <Theme dataTheme="light">
                <App />
            </Theme>
        </GoogleOAuthProvider>
    </QueryClientProvider>
)